import Api from '@/services/Api'

export default {
  getStudCount (params) {
    return Api().post(`curtains/studCount/`, params)
  },

  getFabric (id) {
    return Api().get(`curtains/range/${id}`)
  },

  getTrackPrice (params) {
    return Api().post(`curtains/trackPrice/`, params)
  },

  getBrands (token) {
    return Api().get('curtains/brands/')
  },

  getRanges (brand) {
    return Api().get(`curtains/ranges/${brand}`)
  },

  getBrand (id) {
    return Api().get(`curtains/brand/${id}`)
  },

  getRange (id) {
    return Api().get(`curtains/range/${id}`)
  },

  getAllRange () {
    return Api().get(`curtains/ranges/`)
  },

  addNewBrand (params) {
    return Api().post(`curtains/brands/`, params)
  },

  addNewRange (params) {
    return Api().post(`curtains/ranges/`, params)
  }
}



// WEBPACK FOOTER //
// ./src/services/CurtainService.js